import gql from "graphql-tag";

const RankScore = `
  lastUpdatedAt
  losses
  lp
  promoProgress
  queueType
  rank
  role
  seasonId
  tier
  wins
`;

const PlayerRank = `
  exodiaUuid
  rankScores {
    ${RankScore}
  }
`;

const TeamData = `
  championId
  summonerName
  teamId
  role
  hardCarry
  teamplay
`;

export const MatchSummaryInfo = `
  assists
  championId
  cs
  damage
  deaths
  gold
  items
  jungleCs
  killParticipation
  kills
  level
  matchCreationTime
  matchDuration
  matchId
  maximumKillStreak
  primaryStyle
  queueType
  regionId
  role
  runes
  subStyle
  summonerName
  summonerSpells
  psHardCarry
  psTeamPlay
  lpInfo {
    lp
    placement
    promoProgress
    promoTarget
    promotedTo {
      tier
      rank
    }
  }
  teamA {
    ${TeamData}
  }
  teamB {
    ${TeamData}
  }
  version
  visionScore
  win
`;

export const FETCH_MATCH_SUMMARIES = gql`
  query FetchMatchSummaries(
    $championId: [Int],
    $page: Int,
    $queueType: [Int],
    $duoName: String,
    $regionId: String!,
    $role:  [Int],
    $seasonIds: [Int]!,
    $summonerName: String!
  ) {
    fetchPlayerMatchSummaries(
      championId: $championId,
      page: $page,
      queueType: $queueType,
      duoName: $duoName,
      regionId: $regionId,
      role: $role,
      seasonIds: $seasonIds,
      summonerName: $summonerName
    ) {
      finishedMatchSummaries
      totalNumMatches
      matchSummaries {
        ${MatchSummaryInfo}
      }
    }
  }
`;
